// extracted by mini-css-extract-plugin
export default {"backdrop":"AvailabilitySwitches_backdrop__x1yoP","field":"AvailabilitySwitches_field__ASgDT"};